import { Alert } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import GoogleGps_Map from "src/components/GoogleGPSSelector/GoogleGps_Map";
import { pvmString } from "src/components/js/statics1";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import {
  vehicle_foreignKey_get,
  vehicle_foreignKey_set,
} from "src/components/vehicle/VehicleFunctions";
import { useGridData } from "src/context/GridContext/GridContext";
import { useUserData } from "src/context/userContext";
import { ecofleet_getLocations, ecoFleet_getRawData } from "src/data/ecofleet/ecofleetFunctions";

export default function VehicleInfo_Map({ vehicle }) {
  const { token } = useUserData();
  const { time } = useGridData();

  const [location, setLocation] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    if (!vehicle) return;
    const asynk = async () => {
      setIsLoading(true);
      // get vehicle location
      const locations = await ecofleet_getLocations(vehicle.ownerAsiakasId, token);
      console.log("locations", vehicle);
      const vehicleLocation = locations.find(
        (loc) => loc.plate.replace(" ", "-") === vehicle.vehicleRegNo
      );
      setLocation(vehicleLocation);

      // get vehicle ecoFleet foreignKey
      let foreignKey = await vehicle_foreignKey_get(vehicle.vehicleId, token);
      if (!foreignKey || foreignKey === "undefined") {
        foreignKey = vehicleLocation?.objectId;
        console.log("No foreignKey found for vehicle", vehicle.vehicleId);
        if (!foreignKey) {
          console.log("No foreignKey found for vehicle", vehicle.vehicleId);
          setIsLoading(false);
          setErrorMsg("Ei löytynyt EcoFleet avainta ajoneuvolle " + vehicle.vehicleRegNo);
          return;
        }
        console.log("Save foreignKey", foreignKey + " to vehicle", vehicle.vehicleId);
        // set foreignKey to vehicle
        await vehicle_foreignKey_set(vehicle.vehicleId, vehicleLocation.objectId, token);
      }

      // get vehicle raw data
      //   const begTime = "2025-05-14T00:00:00Z";
      //   const endTime = "2025-05-16T00:00:00Z";
      const begTime = time.starttime.toISOString();
      const endTime = time.endtime.toISOString();

      const rawData = await ecoFleet_getRawData(
        vehicle.ownerAsiakasId,
        foreignKey,
        begTime,
        endTime,
        token
      );
      console.log("rawData", rawData);

      // create markers
      console.log(rawData.stopData);
      const newMarkers = rawData.stopData.map((data, i) => ({
        isStopData: true,
        lat: data.latitude,
        lng: data.longitude,
        label: i.toString(), //"", //vehicle.vehicleRegNo,
        direction: parseFloat(data.direction),
        speed: parseFloat(data.speed),
        engineState: data.enginestate,
        type: "vehicle",
        address: data.address,
        lastEngineOnTime: data.lastEngineOnTime,
        timestamp: data.timestamp,
        startTime: data.startTime,
        endTime: data.endTime,
        durationMinutes: data.durationMinutes,
      }));
      // add vehicle location to markers
      newMarkers.unshift({
        isStopData: false,
        lat: vehicleLocation.latitude,
        lng: vehicleLocation.longitude,
        label: vehicleLocation.plate,
        direction: parseFloat(vehicleLocation.direction),
        speed: parseFloat(vehicleLocation.speed),
        engineState: vehicleLocation.enginestate,
        type: "vehicle",
        address: vehicleLocation.address,
        lastEngineOnTime: vehicleLocation.lastEngineOnTime,
        timestamp: vehicleLocation.timestamp,
        startTime: vehicleLocation.startTime,
        endTime: vehicleLocation.endTime,
        durationMinutes: vehicleLocation.durationMinutes,
      });
      setMarkers(newMarkers);
      setIsLoading(false);
    };
    asynk();
  }, [vehicle, time]);

  if (errorMsg) {
    return (
      <Alert severity="error" style={{ margin: "10px" }}>
        {errorMsg}
      </Alert>
    );
  }
  if (!location) return null;
  if (isLoading) return <ProgressBar show height={4} />;

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <GoogleGps_Map
        markers={markers}
        height="80vh"
        markerSize={6}
        showNextPreviousButtons
        nextPreviousTitle={
          "Ajoneuvon " + vehicle.vehicleRegNo + " pysäytykset " + pvmString(time.starttime)
        }
        selectedMarker={markers[0]} // first marker is the vehicle location
      />
    </div>
  );
}

VehicleInfo_Map.propTypes = {
  vehicle: PropTypes.object,
};
